import moment from "moment";
import React from "react";
import { Button, Modal, Table } from "react-bootstrap";

const CheckAvailablePr = ({ show, onHide, items }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      bsSize="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Previous Refil Orders
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table style={{ textAlign: "center" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>sr No</th>
              <th style={{ textAlign: "center" }}>Medicine Name</th>
              <th style={{ textAlign: "center" }}>Previous Refil ID</th>
              <th style={{ textAlign: "center" }}>Quantity</th>
              <th style={{ textAlign: "center" }}>Created At</th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.medicine_name}</td>
                  <td>{item.purchase_request_id}</td>
                  <td>{item.quantity}</td>
                  <td>
                    {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  No PRs found for this medicine
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckAvailablePr;
